import { Injectable } from '@angular/core';
import { FileUploadRequest } from '../../shared/model/request/file-upload-request';
import { Observable, Subscriber } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpEventType, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { LoggerFactory } from '@elderbyte/ts-logger';
import {NotificationService} from './notification.service';

@Injectable()
export class FileUploadService {

  private static logger = LoggerFactory.getLogger('FileUploadService');

  _headers: HttpHeaders;


  constructor(public _http: HttpClient,  private _notification: NotificationService) {
    this._headers = new HttpHeaders();
    this._headers.set('Content-Type', 'multipart/form-data');
    this._headers.set('enctype', 'multipart/form-data');
  }


  /**
   * Upload a file
   * @param {FileUploadRequest} request Information about the the file
   * @param {string} endpoint The endpoint to upload the file to
   * @param {(loaded, total) => void} progress Function that returns the upload progress
   * @returns {Observable<any>}
   */
  uploadFile(request: FileUploadRequest, endpoint: string, progress?: (loaded, total) => void): Observable<any> {
    return new Observable<any>((subscriber: Subscriber<any>) => {
      const params = new HttpParams();

      // Prepare form data
      const formData: FormData = new FormData();
      formData.append('pUploadFile', request.uploadFile, request.uploadFile.name);

      if (request.requestDefinitionID) {
        formData.append('pRequestDefinitionId', String(request.requestDefinitionID));
      }

      if (request.requestID) {
        formData.append('pRequestId', String(request.requestID));
      }

      this._http.request(new HttpRequest(
        'POST',
        environment.endpoints.clientBaseUrl + endpoint,
        formData,
        {
          reportProgress: true,
          headers: this._headers,
          params: params
        },
      )).subscribe((event: any) => {
        // Progress
        if (event.type === HttpEventType.UploadProgress) {
          FileUploadService.logger.debug(`Upload progress ${event.loaded}/${event.total}`);

          if (progress) {
            progress(event.loaded, event.total);
          }
        }

        // Response
        if (event.type === HttpEventType.Response) {
          subscriber.next(event.body);
          subscriber.complete();
        }
      }, (error: any) => {
        if (this._notification.checkForErrorMessage(error)) {
          this._notification.error(error.error.errorMessage);
        }
      });
    });
  }

}
